import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

export const PageLoader = () =>{
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
      >
        <Loader2 className="w-12 h-12 text-blue-500" />
      </motion.div>

      <motion.p
        initial={{ opacity: 0.3 }}
        animate={{ opacity: 1 }}
        transition={{ repeat: Infinity, duration: 1.2, repeatType: "reverse" }}
        className="text-gray-600 text-lg"
      >
        Loading...
      </motion.p>
    </div>
  );
}
